import axios from 'axios';

const state = {
    inventoryProducts: {},
    adjustments: [],
    movements: [],
};

const mutations = {
    SET_INVENTORY_PRODUCTS(state, { productId, data }) {
        console.log('Storing locations for productId', productId, data)
        if (!state.inventoryProducts) {
          state.inventoryProducts = {}
        }
        state.inventoryProducts[productId] = data
    },
    SET_ADJUSTMENTS(state, data) {
        state.adjustments = Array.isArray(data) ? data : [];
    },
    SET_MOVEMENTS(state, data) {
        state.movements = Array.isArray(data) ? data : [];
    }
};

// store/modules/inventory.js
const actions = {
    async createInventory({ dispatch }, data) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.post(`${baseUrl}/inventory`, data, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            return { status: 'success', message: response.data.message || 'Operation successful' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    async getInventoryProducts({ commit }, product) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        const productId = product.id;
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/inventory/products/${productId}`, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            commit('SET_INVENTORY_PRODUCTS', { productId, data: response.data });
            return { status: 'success' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    async createInventoryMovement(_, movement) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        console.log('Creating inventory movement:', movement);
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            // NOTE: the movements endpoint returns { message }, not inventory data,
            // and the old code committed it under an undefined productId key. The
            // caller reloads the product list after a move, so we simply return the
            // result here instead of committing a bad payload.
            const response = await axios.post(`${baseUrl}/inventory/movements`, movement, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            return { status: 'success', message: response.data.message || 'Operation successful' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    // Historical list of stock write-ups / write-downs (ADD / REMOVE / REGULATE).
    // Replaces the previous stubbed fetchRegulations. Accepts optional filters:
    // { from, to, type, productId }.
    async fetchAdjustments({ commit }, params = {}) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/inventory/adjustments`, {
                headers: { Authorization: `Bearer ${userToken}` },
                params,
            });
            const data = Array.isArray(response.data) ? response.data : [];
            commit('SET_ADJUSTMENTS', data);
            return { status: 'success', data };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            commit('SET_ADJUSTMENTS', []);
            return { status: 'error', message };
        }
    },
    // Historical list of stock movements between locations (MOVE). Accepts
    // optional filters: { from, to, productId, locationId }.
    async fetchMovements({ commit }, params = {}) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/inventory/movements`, {
                headers: { Authorization: `Bearer ${userToken}` },
                params,
            });
            const data = Array.isArray(response.data) ? response.data : [];
            commit('SET_MOVEMENTS', data);
            return { status: 'success', data };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            commit('SET_MOVEMENTS', []);
            return { status: 'error', message };
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};